(function () {
  /* =========================================================
   * GUARD GLOBAL: solo corre en el producto Lunasitol Suscripción
   * =======================================================*/
  const TARGET_HANDLE = 'combo-lunasitol-probioticos-suscripcion';
  if (!window.location.pathname.includes('/products/' + TARGET_HANDLE)) return;

  console.log("Run custom combo lunasitol + probioticos!");

  /* =========================================================
   * Helper: mensaje de validación de reparto de sabores
   * =======================================================*/
  const SABOR_MSG_TEXT = 'Selecciona la cantidad de frascos por sabor antes de continuar.';

  // Muestra el mensaje debajo del .custom-qty-direction de la option indicada
  function showSaborWarning(option) {
    const optSelector = option === '2' ? '.product__option-2'
                      : option === '3' ? '.product__option-3'
                      : null;
    if (!optSelector) return;

    const direction = document.querySelector(optSelector + ' .custom-qty-direction');
    if (!direction) return;

    let msg = direction.parentNode.querySelector('.custom-sabor-warning');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'custom-sabor-warning';
      msg.textContent = SABOR_MSG_TEXT;
      // Estilos mínimos inline (puedes moverlos a CSS del theme)
      msg.style.color = '#c0392b';
      msg.style.fontSize = '13px';
      msg.style.marginTop = '8px';
      msg.style.textAlign = 'center';
      msg.style.width = '100%';
      // Lo insertamos justo después del bloque .custom-qty-direction
      direction.insertAdjacentElement('afterend', msg);
    }
    msg.style.display = 'block';
  }

  // Oculta el mensaje de una option concreta (o de todas si no se pasa option)
  function hideSaborWarning(option) {
    let scope = document;
    if (option === '2' || option === '3') {
      const sel = option === '2' ? '.product__option-2' : '.product__option-3';
      scope = document.querySelector(sel) || document;
    }
    scope.querySelectorAll('.custom-sabor-warning').forEach(m => {
      m.style.display = 'none';
    });
  }

  
  /* =========================================================
   * 1. Toggle Compra única / Suscripción
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    const one = document.querySelector('.custom-subscriptions-one');
    const two = document.querySelector('.custom-subscriptions-two');
    if (!one || !two) return;

    function syncPdpClass() {
      const pdp = document.querySelector('.custom-subs-pdp');
      if (!pdp) return;
      const isPlan = !!document.querySelector('.custom-subscriptions-two.active');
      pdp.classList.toggle('is-plan', isPlan);
    }

    function select(active, inactive) {
      active.classList.add('active');
      inactive.classList.remove('active');
      syncPdpClass();
      document.dispatchEvent(new CustomEvent('subscription:change'));
    }
    one.addEventListener('click', () => select(one, two));
    two.addEventListener('click', () => select(two, one));

    syncPdpClass();
  });

  /* =========================================================
   * 2. Dropdown de plan (data-plan = '1' | '2')
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    const selected = document.querySelector('.custom-plan-selected');
    const plans = document.querySelectorAll('.custom-plan-1, .custom-plan-2');
    if (!selected || !plans.length) return;

    function setInitialPlan() {
      const selectedText = selected.querySelector('p')?.textContent?.trim();
      const plan1Text = document.querySelector('.custom-plan-1 p')?.textContent?.trim();
      selected.dataset.plan = selectedText === plan1Text ? '1' : '2';
    }
    setInitialPlan();

    plans.forEach(plan => {
      plan.addEventListener('click', function () {
        const text = plan.querySelector('p')?.textContent?.trim();
        if (text) selected.querySelector('p').textContent = text;
        selected.dataset.plan = plan.classList.contains('custom-plan-1') ? '1' : '2';
      });
    });
  });

  /* =========================================================
   * 3. Selector de sabores (opt-1 toggle) + reparto (opt-2/3)
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {

    // --- 3a. Activar el bloque de sabor de la option activa ---
    // opt-1 -> .custom-qty-sabor | opt-2/3 -> .custom-qty-direction
    function refreshActiveSaborBlock() {
      const opt1 = document.querySelector('.product__option-1 .custom-qty-sabor');
      const opt2 = document.querySelector('.product__option-2 .custom-qty-direction');
      const opt3 = document.querySelector('.product__option-3 .custom-qty-direction');
      [opt1, opt2, opt3].forEach(el => el && el.classList.remove('active'));

      // (ELIMINADA la restricción de suscripción — ahora aplica en ambos modos)

      const active = document.querySelector(
        '.product__variants .product__option[data-instant-state="active"]'
      );
      if (!active) return;

      if (active.classList.contains('product__option-1') && opt1) opt1.classList.add('active');
      else if (active.classList.contains('product__option-2') && opt2) opt2.classList.add('active');
      else if (active.classList.contains('product__option-3') && opt3) opt3.classList.add('active');
    }

    // Instant cambia data-instant-state sin recargar: observamos los botones.
    const variantsWrap = document.querySelector('.product__variants');
    if (variantsWrap) {
      const obs = new MutationObserver(refreshActiveSaborBlock);
      variantsWrap.querySelectorAll('.product__option').forEach(opt => {
        obs.observe(opt, { attributes: true, attributeFilter: ['data-instant-state'] });
      });
    }
    refreshActiveSaborBlock(); // estado inicial
    document.addEventListener('subscription:change', refreshActiveSaborBlock); // <-- nuevo

    /* --- 3b. Toggle exclusivo en opt-1 (.custom-qty-sabor) --- */
    const sandiaBtn = document.querySelector('.product__option-1 .custom-qty-sabor-sandia');
    const naranjaBtn = document.querySelector('.product__option-1 .custom-qty-sabor-naranja-pina');
    if (sandiaBtn && naranjaBtn) {
      // Estado inicial: sandía seleccionada por defecto
      sandiaBtn.classList.add('active');
      function pick(active, inactive) {
        active.classList.add('active');
        inactive.classList.remove('active');
      }
      sandiaBtn.addEventListener('click', () => pick(sandiaBtn, naranjaBtn));
      naranjaBtn.addEventListener('click', () => pick(naranjaBtn, sandiaBtn));
    }

    /* --- 3c. Counters con reparto acoplado (opt-2 = 2, opt-3 = 3) --- */
    // Devuelve {sandiaEl, naranjaEl, counterEl, total}
    function getDirection(optSelector, total) {
      const root = document.querySelector(optSelector + ' .custom-qty-direction');
      if (!root) return null;
      return {
        root,
        total,
        counterEl: root.querySelector('.custom-qty-direction-counter p'),
        sandiaEl: root.querySelector('.custom-qty-direction-one .custom-qty-direction-btn-number p'),
        naranjaEl: root.querySelector('.custom-qty-direction-two .custom-qty-direction-btn-number p'),
      };
    }

    function setupCounter(optSelector, total) {
      const d = getDirection(optSelector, total);
      if (!d || !d.sandiaEl || !d.naranjaEl) return;

      function read(el) { return parseInt(el.textContent.trim(), 10) || 0; }
      function render() {
        const s = read(d.sandiaEl);
        const n = read(d.naranjaEl);
        if (d.counterEl) d.counterEl.textContent = (s + n) + '/' + total;

        // Si ya está completo, ocultamos el mensaje de esta option
        const optNum = optSelector.includes('option-2') ? '2' : '3';
        if (s + n === total) hideSaborWarning(optNum);
      }

      function change(which, delta) {
        let s = read(d.sandiaEl);
        let n = read(d.naranjaEl);
        const sum = s + n;

        if (delta > 0) {
          // Solo se puede sumar si aún no llegamos al total
          if (sum >= total) {
            // Ya está completo -> modo acoplado: subir uno baja el otro
            if (which === 'sandia' && n > 0) { s += 1; n -= 1; }
            else if (which === 'naranja' && s > 0) { n += 1; s -= 1; }
            // si el otro está en 0, no se puede subir más (quedaría > total)
          } else {
            // Aún acumulando -> sube libre el sabor pedido, sin tocar el otro
            if (which === 'sandia') s += 1;
            else n += 1;
          }
        } else {
          // delta < 0 -> restar (nunca por debajo de 0)
          if (which === 'sandia' && s > 0) s -= 1;
          else if (which === 'naranja' && n > 0) n -= 1;
        }

        d.sandiaEl.textContent = String(s);
        d.naranjaEl.textContent = String(n);
        render();
      }

      const root = d.root;
      const sandiaRow = root.querySelector('.custom-qty-direction-one');
      const naranjaRow = root.querySelector('.custom-qty-direction-two');

      sandiaRow?.querySelector('.custom-qty-direction-btn-minus')
        ?.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); change('sandia', -1); }, true);
      sandiaRow?.querySelector('.custom-qty-direction-btn-plus')
        ?.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); change('sandia', +1); }, true);
      naranjaRow?.querySelector('.custom-qty-direction-btn-minus')
        ?.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); change('naranja', -1); }, true);
      naranjaRow?.querySelector('.custom-qty-direction-btn-plus')
        ?.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); change('naranja', +1); }, true);

      // Estado inicial: 0/0 (el usuario reparte desde cero)
      (function initZero() {
        d.sandiaEl.textContent = '0';
        d.naranjaEl.textContent = '0';
        render();
      })();
    }

    setupCounter('.product__option-2', 2);
    setupCounter('.product__option-3', 3);
  });

  /* =========================================================
   * 4. Interceptor del ATC -> URL de Treli con sabores
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    
    const TRELI_URLS = {
      '1': { // ===== PLAN 1 (mensual) =====
        '1': { // option-1: 1 frasco, un solo sabor
          sandia:  'https://checkout.treli.co/pl/pl_Bia05Dl8DqYjfpqiA04ckUZI', // OK
          naranja: 'https://checkout.treli.co/pl/pl_sasBW3ExtzfBEoZS8ofoqzLh', // OK
        },
        '2': { // option-2: 2 frascos. Clave = "sandia-naranja"
          '2-0': 'https://checkout.treli.co/pl/pl_ruUJ1PxouLY9v4oRM8oqcXRc?quantity=2', // 2 sandía, 0 naranja -- OK
          '1-1': 'https://checkout.treli.co/pl/pl_X7n1dFcRnZRhMmZ4jCkur3YI', // 1 sandía, 1 naranja -- OK
          '0-2': 'https://checkout.treli.co/pl/pl_MzWgqSbfIWHAIbtujCJg8N8o?quantity=2', // 0 sandía, 2 naranja -- OK
        },
        '3': { // option-3: 3 frascos. Clave = "sandia-naranja"
          '3-0': 'https://checkout.treli.co/pl/pl_LtPKQZVQA37DkONScPe6tWKS?quantity=3', // 3 sandía, 0 naranja -- OK
          '2-1': 'https://checkout.treli.co/pl/pl_WFPvwPhUWX25t8nAKOlANas9', // 2 sandía, 1 naranja -- OK
          '1-2': 'https://checkout.treli.co/pl/pl_71QL6FykTHQKOKwyggBrRqxJ', // 1 sandía, 2 naranja -- OK
          '0-3': 'https://checkout.treli.co/pl/pl_zxqA9PH3oREWa9v2SXYqw5Hb?quantity=3', // 0 sandía, 3 naranja -- OK
        },
      },
      '2': { // ===== PLAN 2 (bimensual) =====
        '1': { // option-1: 1 frasco, un solo sabor
          sandia:  'https://checkout.treli.co/pl/pl_cb2pbbWqmr6gvmA3ekurq2NW', // OK
          naranja: 'https://checkout.treli.co/pl/pl_gcDexJEfAMFHY2kVF0kw6ycP', // OK
        },
        '2': { // option-2: 2 frascos. Clave = "sandia-naranja"
          '2-0': 'https://checkout.treli.co/pl/pl_a1bgzuPSBo3fZkfMAsuSVaAz?quantity=2', // 2 sandía, 0 naranja -- OK
          '1-1': 'https://checkout.treli.co/pl/pl_Kxw8YX7eVOAwcr3y2dpN8QSO', // 1 sandía, 1 naranja -- OK
          '0-2': 'https://checkout.treli.co/pl/pl_oTUFt4Ft7uAFkias2cjjthJm?quantity=2', // 0 sandía, 2 naranja -- OK
        },
        '3': { // option-3: 3 frascos. Clave = "sandia-naranja"
          '3-0': 'https://checkout.treli.co/pl/pl_vGh4A4x3OVnaCaR3MXw6HoFq?quantity=3', // 3 sandía, 0 naranja -- OK
          '2-1': 'https://checkout.treli.co/pl/pl_XlRYHuiMikJW9kCchtixJDIw', // 2 sandía, 1 naranja -- OK
          '1-2': 'https://checkout.treli.co/pl/pl_X1zBIacPKIeDJkcWmQjxWzrP', // 1 sandía, 2 naranja -- OK
          '0-3': 'https://checkout.treli.co/pl/pl_27E0e3Zu5trNJOyyjjUMLS8U?quantity=3', // 0 sandía, 3 naranja -- OK
        },
      },
    };

    function getActivePlan() {
      return document.querySelector('.custom-plan-selected')?.dataset.plan || null;
    }

    function getActiveOption() {
      const opt = document.querySelector(
        '.product__variants .product__option[data-instant-state="active"]'
      );
      if (!opt) return null;
      if (opt.classList.contains('product__option-1')) return '1';
      if (opt.classList.contains('product__option-2')) return '2';
      if (opt.classList.contains('product__option-3')) return '3';
      return null;
    }

    function isSubscriptionActive() {
      return !!document.querySelector('.custom-subscriptions-two.active');
    }

    function readNum(el) { return el ? (parseInt(el.textContent.trim(), 10) || 0) : 0; }

    // Devuelve {sandia, naranja} según la option
    function getSaborQuantities(option) {
      if (option === '1') {
        const sandiaActive = document
          .querySelector('.product__option-1 .custom-qty-sabor-sandia')
          ?.classList.contains('active');
        return sandiaActive ? { sandia: 1, naranja: 0 } : { sandia: 0, naranja: 1 };
      }
      const optSelector = option === '2' ? '.product__option-2' : '.product__option-3';
      const sandiaEl = document.querySelector(
        optSelector + ' .custom-qty-direction .custom-qty-direction-one .custom-qty-direction-btn-number p'
      );
      const naranjaEl = document.querySelector(
        optSelector + ' .custom-qty-direction .custom-qty-direction-two .custom-qty-direction-btn-number p'
      );
      return { sandia: readNum(sandiaEl), naranja: readNum(naranjaEl) };
    }

    function buildUrl(baseUrl, qty) {
      const params = new URLSearchParams();
      params.set('sandia', qty.sandia);
      params.set('naranjapina', qty.naranja);
      return baseUrl + '?' + params.toString();
    }

    // Valida que la suma sea la esperada según la option
    function isComplete(option, qty) {
      const expected = option === '1' ? 1 : option === '2' ? 2 : 3;
      return (qty.sandia + qty.naranja) === expected;
    }


  // Devuelve 'sandia' | 'naranja' según el toggle activo en option-1
    function getActiveSabor() {
      const sandiaActive = document
        .querySelector('.product__option-1 .custom-qty-sabor-sandia')
        ?.classList.contains('active');
      return sandiaActive ? 'sandia' : 'naranja';
    }


    function handleAtcClick(e) {
      if (!isSubscriptionActive()) return; // compra única -> flujo normal (bloque X)

      // A partir de aquí SIEMPRE es suscripción: bloqueamos el flujo nativo
      // para que NUNCA agregue al carrito, pase lo que pase.
      e.preventDefault();
      e.stopImmediatePropagation();

      const plan = getActivePlan();
      const option = getActiveOption();
      if (!plan || !option) {
        console.warn('Treli: plan u option no detectados', { plan, option });
        return;
      }

      const entry = TRELI_URLS[plan]?.[option];
      if (!entry) {
        console.warn('Treli: no hay entry para', plan, option);
        return;
      }

      // --- option-1: URL directa por sabor ---
      if (option === '1') {
        const sabor = getActiveSabor();
        const url = entry[sabor];
        if (!url) {
          console.warn('Treli: falta link option-1', plan, sabor);
          return;
        }
        window.location.href = url;
        return;
      }

      // --- option-2 / option-3: clave "sandia-naranja" ---
      const qty = getSaborQuantities(option);

      if (!isComplete(option, qty)) {
        showSaborWarning(option);
        console.warn('Treli: reparto incompleto', qty);
        return;
      }
      hideSaborWarning(option);

      const key = qty.sandia + '-' + qty.naranja; // ej. "1-2"
      const url = entry[key];
      if (!url) {
        console.warn('Treli: falta link para', plan, option, key);
        return;
      }

      window.location.href = url;
    }

    const atcBtn = document.querySelector('.atc__btn');
    if (atcBtn) atcBtn.addEventListener('click', handleAtcClick, true);
  });


  /* =========================================================
   * 5. Sufijo "(Cada Mes)" en los títulos de opción (solo suscripción)
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    const SUFFIX = ' (Cada Mes)';

    function refreshTitles() {
      const isSub = !!document.querySelector('.custom-subscriptions-two.active');
      const titles = document.querySelectorAll('.product__option-title p');

      titles.forEach(p => {
        if (p.dataset.baseHtml === undefined) p.dataset.baseHtml = p.innerHTML;

        const hasSuffix = p.innerHTML.trimEnd().endsWith(SUFFIX.trim());

        if (isSub && !hasSuffix) {
          p.innerHTML = p.dataset.baseHtml + SUFFIX;
        } else if (!isSub && hasSuffix) {
          p.innerHTML = p.dataset.baseHtml;
        }
      });
    }

    refreshTitles();
    document.addEventListener('subscription:change', refreshTitles);
  });


  /* =========================================================
   * 6. Precio según la option activa (solo suscripción)
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    const PRICES = {
      '1': '$189.000',
      '2': '$169.500',
      '3': '$159.666',
    };

    function getActiveOption() {
      const opt = document.querySelector(
        '.product__variants .product__option[data-instant-state="active"]'
      );
      if (!opt) return null;
      if (opt.classList.contains('product__option-1')) return '1';
      if (opt.classList.contains('product__option-2')) return '2';
      if (opt.classList.contains('product__option-3')) return '3';
      return null;
    }

    function refreshPrice() {
      const priceEl = document.querySelector('.custom-selected-price-plan p');
      if (!priceEl) return;

      const option = getActiveOption();
      if (option && PRICES[option]) {
        priceEl.textContent = PRICES[option];
      }
    }

    // Actualiza al cambiar de option (Instant cambia data-instant-state)
    const variantsWrap = document.querySelector('.product__variants');
    if (variantsWrap) {
      const obs = new MutationObserver(refreshPrice);
      variantsWrap.querySelectorAll('.product__option').forEach(opt => {
        obs.observe(opt, { attributes: true, attributeFilter: ['data-instant-state'] });
      });
    }

    refreshPrice(); // estado inicial
  });


  /* =========================================================
   * 7. .custom-pdp-price span = precio del plan cuando hay suscripción
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    const pdpEl = document.querySelector('.custom-pdp-price');
    const planP = document.querySelector('.custom-selected-price-plan p');
    if (!pdpEl || !planP) return;

    let basePrice;        // precio compra única, se fija en el primer span válido
    let isWriting = false; // evita loop con nuestro propio self-observer

    function isSubscriptionActive() {
      return !!document.querySelector('.custom-subscriptions-two.active');
    }

    function getSpan() {
      return pdpEl.querySelector('span'); // se re-resuelve por si Instant lo recreó
    }

    function desiredPrice() {
      if (isSubscriptionActive()) {
        return planP.textContent.trim() || basePrice;
      }
      return basePrice;
    }

    function refreshPdpPrice() {
      const span = getSpan();
      if (!span) return;

      // Fijamos el precio base la primera vez que hay un span con valor
      if (basePrice === undefined) {
        const t = span.textContent.trim();
        if (t) basePrice = t;
      }

      const value = desiredPrice();
      if (!value || span.textContent.trim() === value) return;

      isWriting = true;
      span.textContent = value;
      // liberar en microtask, no en rAF: el observer #4 dispara en el mismo tick
      Promise.resolve().then(() => { isWriting = false; });
    }

    // 1) Toggle Compra única / Suscripción
    document.addEventListener('subscription:change', refreshPdpPrice);

    // 2) Cambio de option activa (data-instant-state)
    const variantsWrap = document.querySelector('.product__variants');
    if (variantsWrap) {
      const obs = new MutationObserver(refreshPdpPrice);
      variantsWrap.querySelectorAll('.product__option').forEach(opt => {
        obs.observe(opt, { attributes: true, attributeFilter: ['data-instant-state'] });
      });
    }

    // 3) Cuando la sección 6 reescribe el plan-price (p)
    new MutationObserver(function () {
      if (isSubscriptionActive()) refreshPdpPrice();
    }).observe(planP, { childList: true, characterData: true, subtree: true });

    // 4) Cuando Instant repinta el span, lo corregimos (observamos el PADRE)
    new MutationObserver(function () {
      if (isWriting) return;
      refreshPdpPrice();
    }).observe(pdpEl, { childList: true, characterData: true, subtree: true });

    // 5) El bloque nativo de Instant escribe el precio de la VARIANTE en
    //    .custom-pdp-price al hacer click en una option. En suscripción
    //    volvemos a imponer el precio del plan, DESPUÉS de ese script.
    if (variantsWrap) {
      variantsWrap.querySelectorAll('.product__option').forEach(opt => {
        opt.addEventListener('click', function () {
          if (!isSubscriptionActive()) return;
          requestAnimationFrame(refreshPdpPrice);
          setTimeout(refreshPdpPrice, 0);
        });
      });
    }

    refreshPdpPrice(); // inicial
  });

  /* =========================================================
   * 8. Precio /DÍA de cada option según el plan (1 mes vs 2 meses)
   *    Plan 2 (cada 2 meses) -> el costo/día se divide entre 2
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    // Formatea un número entero a formato COP: 1685 -> "$1.685"
    function formatCOP(num) {
      return '$' + Math.round(num).toLocaleString('es-CO');
    }

    // Extrae el entero desde "$1.685/DÍA" -> 1685 (quita $, puntos y texto)
    function parseCOP(text) {
      const digits = text.replace(/[^\d]/g, '');
      return parseInt(digits, 10) || 0;
    }

    // El sufijo que acompaña al número (ej. "/DÍA")
    function getSuffix(text) {
      // todo lo que va después del último dígito
      const m = text.match(/[\d.]+\s*(.*)$/);
      return m ? m[1] : '';
    }

    function getActivePlan() {
      return document.querySelector('.custom-plan-selected')?.dataset.plan || '1';
    }

    // Recolecta los badges /DÍA (los .white-badge de cada option)
    const badges = Array.from(
      document.querySelectorAll('.product__variants .product__option .product__info--badge.white-badge')
    );

    // Guardamos el valor BASE (plan 1) de cada badge una sola vez
    badges.forEach(b => {
      if (b.dataset.baseDia === undefined) {
        b.dataset.baseDia = String(parseCOP(b.textContent));
        b.dataset.suffix = getSuffix(b.textContent.trim());
      }
    });

    function refreshDiaBadges() {
      const plan = getActivePlan();
      const divisor = plan === '2' ? 2 : 1;

      badges.forEach(b => {
        const base = parseInt(b.dataset.baseDia, 10) || 0;
        if (!base) return;
        const suffix = b.dataset.suffix || '/DÍA';
        b.textContent = ' ' + formatCOP(base / divisor) + suffix + ' ';
      });
    }

    // 1) Al cambiar de plan en el dropdown (.custom-plan-1 / .custom-plan-2)
    document.querySelectorAll('.custom-plan-1, .custom-plan-2').forEach(plan => {
      plan.addEventListener('click', function () {
        // diferimos para que la sección 2 ya haya actualizado dataset.plan
        requestAnimationFrame(refreshDiaBadges);
        setTimeout(refreshDiaBadges, 0);
      });
    });

    refreshDiaBadges(); // estado inicial
  });



  /* =========================================================
   * X. Compra única (SOLO handle lunasitol-test):
   *    mapear sabores -> variantes reales, agregar con add.js
   *    y refrescar el drawer de Instant vía su API interna.
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    const atcBtn = document.querySelector('.atc__btn');
    if (!atcBtn) return;

    /*
    const VARIANTS = {
      sandia: 53733622251834,
      naranja: 53733629788474,
      probiotico: 53423050588474 // original
    };
    */

    const VARIANTS = {
      sandia: 53733622251834,
      naranja: 53733629788474,
      probiotico: 53756875571514
    };

    function isSubscriptionActive() {
      return !!document.querySelector('.custom-subscriptions-two.active');
    }

    function getActiveOption() {
      const opt = document.querySelector(
        '.product__variants .product__option[data-instant-state="active"]'
      );
      if (!opt) return null;
      if (opt.classList.contains('product__option-1')) return '1';
      if (opt.classList.contains('product__option-2')) return '2';
      if (opt.classList.contains('product__option-3')) return '3';
      return null;
    }

    function readNum(el) {
      return el ? (parseInt(el.textContent.trim(), 10) || 0) : 0;
    }

    function buildItems() {
      const option = getActiveOption();
      if (!option) return [];

      // option-1: un solo sabor (toggle)
      if (option === '1') {
        const sandiaActive = document
          .querySelector('.product__option-1 .custom-qty-sabor-sandia')
          ?.classList.contains('active');
        const id = sandiaActive ? VARIANTS.sandia : VARIANTS.naranja;
        return [{ id: id, quantity: 1 }];
      }

      // option-2 / option-3: cantidades por sabor
      const optSelector = option === '2' ? '.product__option-2' : '.product__option-3';
      const sandiaQty = readNum(document.querySelector(
        optSelector + ' .custom-qty-direction-one .custom-qty-direction-btn-number p'
      ));
      const naranjaQty = readNum(document.querySelector(
        optSelector + ' .custom-qty-direction-two .custom-qty-direction-btn-number p'
      ));

      const items = [];
      if (sandiaQty > 0) items.push({ id: VARIANTS.sandia, quantity: sandiaQty });
      if (naranjaQty > 0) items.push({ id: VARIANTS.naranja, quantity: naranjaQty });
      return items;
    }

    function isComplete(option, items) {
      const total = items.reduce((s, it) => s + it.quantity, 0);
      const expected = option === '1' ? 1 : option === '2' ? 2 : 3;
      return total === expected;
    }

    atcBtn.addEventListener('click', function (e) {
      if (isSubscriptionActive()) return;  // suscripción -> bloque 4 (Treli)

      const option = getActiveOption();
      const items = buildItems();
      // if (!items.length) return;
      if (!option) return;

      if (!isComplete(option, items)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showSaborWarning(option)
        console.warn('Reparto de sabores incompleto:', items);
        return;
      }
      hideSaborWarning(option);

      e.preventDefault();
      e.stopImmediatePropagation();

       // El probiótico acompaña 1:1 la cantidad de frascos de la option
      const probioticoQty = option === '1' ? 1 : option === '2' ? 2 : 3;
      const payload = items.concat([{ id: VARIANTS.probiotico, quantity: probioticoQty }]);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: payload })
      })
        .then(r => r.json())
        .then((cart) => {
          console.log("cart add", cart)
          // Refresca el drawer de Instant con su API interna (sin recargar)
          if (window.Instant?.api?.updateCart) {
            return window.Instant.api.updateCart();
          }
        })
        .then(() => {
          // Abre el drawer
          if (window.Instant?.api?.toggleCart) {
            window.Instant.api.toggleCart();
          }
        })
        .catch(err => {
          console.error('Error agregando sabores al carrito:', err);
          const href = atcBtn.getAttribute('href');
          if (href) window.location.href = href;
        });
    }, true);
  });






  /* =========================================================
   * Y. Al cargar con ?open_cart=1, abrir el cart drawer de Instant
   * =======================================================*/
  (function () {
    const params = new URLSearchParams(window.location.search);
    if (params.get('open_cart') !== '1') return;

    params.delete('open_cart');
    const clean = window.location.pathname +
      (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', clean);

    let done = false; // candado: solo un click en toda la vida del script

    let tries = 0;
    const maxTries = 60;

    function attempt() {
      if (done) return;               // ya clickeamos, no hacer nada más

      const trigger = document.querySelector('.custom-cart-toggle');
      if (trigger) {
        done = true;                  // cerramos el candado ANTES del click
        trigger.click();
        return;                       // no reprogramar
      }

      if (++tries < maxTries) {
        setTimeout(attempt, 150);
      }
    }

    window.addEventListener('load', function () {
      setTimeout(attempt, 500);
    });
  })();


  /* =========================================================
   * W. Frecuencia "(Cada Mes)" / "(Cada 2 Meses)" en cada
   *    .product__option-title según el plan activo (.custom-plan-1/2)
   *    Solo aplica en modo suscripción.
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    const titles = Array.from(document.querySelectorAll('.product__option-title p'));
    if (!titles.length) return;

    // Guardamos la base (sin frecuencia) una vez, desde data-base-html
    titles.forEach(p => {
      if (p.dataset.baseTitle === undefined) {
        // preferimos data-base-html; si no existe, usamos el HTML actual
        // pero recortando cualquier " (Cada ...)" ya presente
        const base = p.getAttribute('data-base-html')
          || p.innerHTML.replace(/\s*\(Cada[^)]*\)\s*$/i, '');
        p.dataset.baseTitle = base.trim();
      }
    });

    function isSubscriptionActive() {
      return !!document.querySelector('.custom-subscriptions-two.active');
    }

    // Texto de frecuencia según el plan seleccionado
    function getFrecuencia() {
      // El plan activo es el que tiene la clase .custom-plan-selected reflejando
      // .custom-plan-2, o detectamos por cuál fue clickeado. Usamos el texto
      // de la opción activa del dropdown.
      const plan2Active = document.querySelector('.custom-plan-2.custom-plan-active, .custom-plan-2.active');
      // Fallback: leer el texto actual de .custom-plan-selected
      const selectedTxt = document.querySelector('.custom-plan-selected p')?.textContent || '';
      const isPlan2 = plan2Active || /2\s*Meses/i.test(selectedTxt);
      return isPlan2 ? 'Cada 2 Meses' : 'Cada Mes';
    }

    function refreshTitles() {
      const sub = isSubscriptionActive();
      const frec = getFrecuencia();

      titles.forEach(p => {
        const base = p.dataset.baseTitle;
        if (sub) {
          const nuevo = base + ' (' + frec + ')';
          if (p.innerHTML !== nuevo) p.innerHTML = nuevo;
        } else {
          // Compra única: sin frecuencia (o deja solo la base)
          if (p.innerHTML !== base) p.innerHTML = base;
        }
      });
    }

    // Al cambiar plan
    document.querySelectorAll('.custom-plan-1, .custom-plan-2').forEach(el => {
      el.addEventListener('click', function () {
        requestAnimationFrame(refreshTitles);
        setTimeout(refreshTitles, 0);
      });
    });

    // Al alternar suscripción / compra única
    document.addEventListener('subscription:change', refreshTitles);

    refreshTitles(); // inicial
  });

})();